import { Formik } from 'formik';
import React from 'react';
import {
  Container,
  Divider,
  Form,
  Header,
  Button,
  Message,
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'types/provider';
import { request } from 'utils/api';
import SearchDropdownField from 'components/form-fields/formik/SearchDropdown';
import CheckboxField from 'components/form-fields/formik/CheckboxField';
// import styles from './Settings.module.css';
const SettingsBilling: React.FC<{
  provider: Partial<Provider>;
}> = ({ provider }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h2" style={{ padding: '0', margin: '0' }}>
        {t('editSandboxBilling.title', 'Billing')}
      </Header>
      <Divider />
      <p>{t('editSandboxBilling.description', 'Billing settings')}</p>
      <Formik
        enableReinitialize
        initialValues={{
          enableMultiCurrency: provider.enableMultiCurrency,
          enableInvoicing: provider.enableInvoicing,
          enableAdvancedInvoicing: provider.enableAdvancedInvoicing,
          billingEntityId: provider.billingEntityId,
        }}
        onSubmit={(values) => {
          request({
            method: 'PATCH',
            path: `/1/sandboxes/${(provider as any)._id}/settings`,
            body: {
              ...provider,
              ...values,
            },
          });
        }}>
        {({ handleSubmit, values, isSubmitting, isValid, dirty }) => {
          return (
            <Form>
              <Form.Field>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxBilling.enableMultiCurrency',
                    'Enable Multi Currency Support'
                  )}
                  name="enableMultiCurrency"
                />
                <Message info>
                  {t(
                    'editSandboxBilling.enableMultiCurrencyDescription',
                    'Allows the platform to handle multiple currencies for international operations, including automatic conversion and localized pricing.'
                  )}
                </Message>
              </Form.Field>
              <Form.Field>
                <CheckboxField
                  toggle
                  disabled
                  label={t(
                    'editSandboxBilling.enableInvoicing',
                    'Enable Invoicing?'
                  )}
                  name="enableInvoicing"
                />
                <Message info>
                  {t(
                    'editSandboxBilling.enableInvoicingDescription',
                    'Enables invoicing, which allows for billing based on the invoicing platform.'
                  )}
                </Message>
                {values.enableInvoicing && (
                  <>
                    {values.enableInvoicing && (
                      <p style={{ fontStyle: 'italic' }}>
                        {t(
                          'editSandboxBilling.enableInvoicingNote',
                          'Note a billing entity must be provided above if this option is selected!'
                        )}
                      </p>
                    )}
                    <SearchDropdownField
                      name="billingEntityId"
                      label={t(
                        'editSandboxBilling.billingEntity',
                        'Billing Entity'
                      )}
                      key={values.billingEntityId}
                      clearable
                      getOptionLabel={(item: any) =>
                        `${item.name} ${item.taxResidencyCountryCode}`
                      }
                      onDataNeeded={() => {
                        return request({
                          path: '/1/billing-entities',
                          method: 'GET',
                        });
                      }}
                    />
                  </>
                )}
              </Form.Field>
              <Form.Field>
                <CheckboxField
                  toggle
                  disabled={!values.enableInvoicing}
                  label={t(
                    'editSandboxBilling.enableAdvancedInvoicing',
                    'Enable Advanced Invoicing Options (e.g. itemized breakdowns)'
                  )}
                  name="enableAdvancedInvoicing"
                />
                <Message info>
                  {t(
                    'editSandboxBilling.enableAdvancedInvoicingDescription',
                    'Provides detailed invoicing features including itemized breakdowns, custom billing periods, and advanced reporting options.'
                  )}
                </Message>
              </Form.Field>
              <Button
                disabled={isSubmitting || !isValid}
                onClick={() => handleSubmit()}
                primary>
                {t('save', 'Save')}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default SettingsBilling;
